export default __webpack_public_path__ + "static/media/1924.71e1e6b1.png";